import topbar from '../../vendor/topbar';
import {
  maybeCollapseGamesListForWorkspaceChange,
  bindGameHubNavToggle,
} from '../../rescript/src/hooks/GamesListCollapseHook.res.mjs';
import { applyPersistedMainNavRail } from '../../rescript/src/hooks/MainNavRailHook.res.mjs';
import { syncAppSidebarPad } from '../../rescript/src/hooks/SidebarPadSyncHook.res.mjs';
import { hideReconnectFlashBannersUnlessLiveViewError } from './reconnect-flash.ts';
import { persistCatalogueContextFromPath } from './workspace-context.ts';

/** Pathname before each LiveView loading cycle — collapse LHSP when switching app areas. */
let lhspWorkspacePrevPathname = window.location.pathname;

function onPageLoadingStart(): void {
  topbar.show(300);
  hideReconnectFlashBannersUnlessLiveViewError();
}

function onPageLoadingStop(): void {
  topbar.hide();
  hideReconnectFlashBannersUnlessLiveViewError();

  const nextPath = window.location.pathname;
  maybeCollapseGamesListForWorkspaceChange(lhspWorkspacePrevPathname, nextPath);
  persistCatalogueContextFromPath(nextPath);
  lhspWorkspacePrevPathname = nextPath;

  applyPersistedMainNavRail();
  syncAppSidebarPad();
}

/**
 * Topbar, reconnect-flash suppression, nav rail/pad, and LHSP workspace collapse.
 */
export function bindShellChrome(): void {
  topbar.config({
    barColors: { 0: 'oklch(0.67 0.22 36.99)' },
    shadowColor: 'rgba(0, 0, 0, .3)',
  });

  window.addEventListener('phx:page-loading-start', onPageLoadingStart);
  window.addEventListener('phx:page-loading-stop', onPageLoadingStop);

  // Full live navigations (not push_patch) also flash reconnect toasts.
  window.addEventListener('phx:navigate', (e: Event) => {
    const detail = (e as CustomEvent<{ patch?: boolean } | undefined>).detail;
    if (detail?.patch) return;
    hideReconnectFlashBannersUnlessLiveViewError();
  });

  applyPersistedMainNavRail();
  syncAppSidebarPad();
  bindGameHubNavToggle();

  // After first paint, suppress stray banners (race before phx-connected).
  requestAnimationFrame(() => {
    hideReconnectFlashBannersUnlessLiveViewError();
  });
}
